/**
 * Project : workspace
 * File    : CreateBusinessType.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.business.onboard.select_business_type

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Modifier
import com.parmartechnologies.business.feature.businessType.viewModel.BusinessTypeViewModel
import component.button.DefaultButton
import component.input.TextInputField
import component.navigation.TopNavBar
import navigation.AppNavigator
import theme.ThemeColor

/**
 * Represents the create business type class.
 */

class CreateBusinessType{
    @Composable
    fun Content() {
        val viewModel = BusinessTypeViewModel()
        val businessTypes = viewModel.allBusinessType.collectAsState()
        LaunchedEffect(key1 = Unit) {
            viewModel.retrieve()
        }
        Column(
            modifier = Modifier.fillMaxSize().background(ThemeColor.shared().defaultBakground)

        ) {
            TopNavBar(
                title = "Create Business Type",
                onBackPress = {
                    AppNavigator.shared().goBack()
                })
            TextInputField("Business Type", "Enter Business Type Name", "", onChange = {})
                DefaultButton("Save", {
                    onClickSave()
                })

        }
    }

    private fun onClickSave() {

    }
}